import React from "react";
import { Form, Icon, Input, Button, message } from 'antd';
import { tool } from "rt-sd-common";



class FirstLoginChgPwdC extends React.Component {
    constructor(props) {
        super(props);

    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                // tool.sgiLogger.info('Received values of form: ', values);
                if (values.userPassword === values.confirmUserPassword) {
                    values.userPassword = tool.encrypt(values.userPassword);
                    let req = {
                        userPassword: values.userPassword,
                    }

                    var success = function (res) {
                        // tool.sgiLogger.info(res, 'firstUpdatePassword')
                        if (res && res.head.code == "0000") {
                            tool.setCookie("passwordStatus", "0", .5);
                            tool.popSingleUI('/main');
                        } else {
                            message.error(res.head.msg);
                        }
                    };
                    commonClient.simplecall(sgiConfig.allUrl.firstUpdatePassword, req, success)

                } else {
                    message.error("确认密码与新密码不一致！");
                }
            }
        });
    };
    render() {
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };

        return <div style={{ height: "100%", width: "100%" }}>
            <div style={{
                width: "400px",
                margin: "0 auto ",
                transform: "translateY(-60%)",
                position: "relative",
                top: "50%",
            }}>
                <div style={{ marginBottom: "20px", fontSize: "20px", textAlign: 'center' }}>首次登录设置新密码</div>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Form.Item label="新密码">
                        {getFieldDecorator('userPassword', {
                            rules: [{ required: true, message: '请输入新密码!' }],
                        })(
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                placeholder="新密码"
                            />,
                        )}
                    </Form.Item>
                    <Form.Item label="确认新密码">
                        {getFieldDecorator('confirmUserPassword', {
                            rules: [{ required: true, message: '请输入确认密码!' }],
                        })(
                            <Input
                                prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                type="password"
                                placeholder="确认密码"
                            />,
                        )}
                    </Form.Item>
                    <Form.Item style={{ textAlign: "center" }}>
                        <Button type="primary" htmlType="submit">确定</Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    }
}

const FirstLoginChgPwd = Form.create({ name: 'login' })(FirstLoginChgPwdC);
export default FirstLoginChgPwd;


// WEBPACK FOOTER //
// ./apps/pages/login/FirstLoginChgPwd.js